/**
 * @file Reusable page header component.
 * @description Standardized gradient page header with optional icon and actions.
 * @author Sanjay Jangid (Jiggle frontend)
 * @email sanjay.jangid@dgtoohl.com
 * @date 2026-05-10
 * @version 0.0.0
 */
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '../../utils/cn';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: LucideIcon;
  actions?: React.ReactNode;
  className?: string;
  gradientClassName?: string;
  subtitleClassName?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  icon: Icon,
  actions,
  className,
  gradientClassName = 'from-primary-500 to-secondary-500',
  subtitleClassName = 'text-primary-100 text-sm',
}) => {
  return (
    <div
      className={cn(
        'bg-gradient-to-r rounded-lg p-6 text-white',
        gradientClassName,
        className,
      )}
    >
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center">
          {Icon ? <Icon size={32} className="mr-4" /> : null}
          <div>
            <h1 className="text-2xl font-semibold mb-0">{title}</h1>
            {subtitle ? <p className={subtitleClassName}>{subtitle}</p> : null}
          </div>

        </div>
        {actions ? <div>{actions}</div> : null}
      </div>
    </div>
  );
};

export default PageHeader;
